// Import 3rd party libraries
import {gsap} from "gsap";
import { CustomEase} from "gsap/CustomEase";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

export default function() {
    const matches = {
        isMobile: "(max-width: 767px)",
        isTablet: "(min-width: 768px) and (max-width: 991px)",
        isLaptop: "(min-width: 992px) and (max-width: 1199px)",
        isDesktop: "(min-width: 1200px) and (max-width: 1399px)",
        isTV: "(min-width: 1400px)",
        reduceMotion: "(prefers-reduced-motion: reduce)"
    }
    
    let mm = gsap.matchMedia();
    
    mm.add(matches, (context) => {
        let events = document.querySelectorAll("#events-container > div");

        gsap.timeline({
            scrollTrigger: {
                trigger: "#articles",
                start: "clamp(top, 75%)",
                end: "clamp(top, 50%)",
            }
        })

        /**
         * Show the news image
         */
        .fromTo("#main-news-article img", 
            {
                "clip-path": "polygon(50% 0%, 50% 0%, 50% 100%, 50% 100%)",
            }, 
            {
                "clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                duration: 2,
                ease: "power2.out",
            }
        )

        .to("#main-news-article .news-background", {
            "--gradient-linear-length": "85%",
            duration: 1,
        })

        .from("#main-news-article .news-title", {
            opacity: 0,
            y: 50,
            duration: 1.5,
        }, "-=75%")

        .from("#news-articles-list li", {
            stagger: .1,
            delay: () => Math.random().toFixed(2) * 0.5,
            duration: () => Math.random().toFixed(2) + 1,
            x: "70",
            opacity: 0,
        }, "-=2.5");

        gsap.from([...events].reverse(), {
            scrollTrigger: {
                trigger: "#events-container",
                start: "clamp(top, 85%)",
                end: "clamp(top, 50%)",
            },
            stagger: .3,
            duration: 1,
            xPercent: function() {
                let position = this._targets[0].dataset.position;

                return -((+position) * 100);
            },
            ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.328,1.03 0.416,1.054 0.482,1.072 0.516,0.988 0.548,0.988 0.577,0.988 0.618,1.017 0.652,1.018 0.688,1.018 0.69,1 0.732,1 0.764,1 0.758,1.012 0.794,1.012 0.84,1.012 0.855,1 0.9,1 0.948,1 0.982,1 1,1")
        });
    });
}